import { useFormContext } from 'react-hook-form';

import { FormField, FormSelect } from '@/_components';

import { awardTypeOptions } from './schema';

export function AwardTypeInput({ isEditable }: { isEditable?: boolean }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="award_type"
      render={({ field: { value, onChange } }) => (
        <FormSelect
          disabled={!isEditable}
          value={value}
          getOptionLabel={(option) => option.name}
          onChange={onChange}
          options={awardTypeOptions}
          label="Award Type"
        />
      )}
    />
  );
}
